import { Type } from '@angular/core';
import { IChatFormControl } from '@nimbus-global/features/chat-form/models/chat-form.model';

export enum ChatFormTenantMode {
  Fixed = 'fixed',
  Selector = 'selector',
}

export interface ChatFormTenantResolution {
  mode: ChatFormTenantMode;
  tenantId: string;
  component: Type<IChatFormControl>;
}

export type ChatFormTenantResolver = () => ChatFormTenantResolution;
